import { gql } from '@apollo/client';

export const FETCH_MODEL_SELECTION_TASKS = gql`
  query FetchModelSelectionTasks($assignmentId: Int!) {
    tasksPerAssignment(assignment_id: $assignmentId) {
      id
      task_type_id
      task_data_id
      status_id
      project_id
      assignment_id
      is_bookmarked
      notes {
        id
        text
        createdAt
        userDetails {
          userId
          name
          role
        }
      }
      data {
        ... on TaskModelSelectionData {
          best_translated_sentence_id
          options {
            id
            model_id
            translated_sentence_id
            translated_sentence {
              sentence_text
            }
          }
          source_sentence {
            id
            sentence_text
            sentence_number
            book_id
            book_title
            chapter_id
            chapter_title
          }
        }
      }
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation ModelSelectionUpdateTask($id: Int!, $task: UpdateTaskInput!) {
    updateTask(id: $id, task: $task) {
      id
      status_id
    }
  }
`;

export const BOOKMARK_TASK = gql`
  mutation ModelSelectionBookmarkTask($id: Int!, $is_bookmarked: Boolean!) {
    bookmarkTask(id: $id, is_bookmarked: $is_bookmarked) {
      id
      is_bookmarked
    }
  }
`;

export const UPDATE_TASK_MODEL_SELECTION = gql`
  mutation UpdateTaskModelSelection(
    $id: Int!
    $bestTranslatedSentenceId: Int!
    $modelId: String!
  ) {
    updateTaskModelSelection(
      id: $id
      best_translated_sentence_id: $bestTranslatedSentenceId
      model_id: $modelId
    ) {
      id
      bestTranslatedSentenceId
    }
  }
`;

export const CALCULATED_MODEL_QUERY = gql`
  query CalculatedModel($projectId: Int!, $levelId: Int!) {
    calculatedModelForProject(projectId: $projectId, levelId: $levelId) {
      projectId
      levelId
      calculatedModelId
    }
  }
`;

export const UPDATE_SELECTED_MODEL_MUTATION = gql`
  mutation UpdateSelectedModelForProject($projectId: Int!, $modelId: String!) {
    updateSelectedModelForProject(projectId: $projectId, modelId: $modelId) {
      projectId
      selectedModelId
    }
  }
`;
